module.exports = __webpack_public_path__ + "files/305738de444e252db265b3d67b43631c.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-bolditalic-webfont.woff2
 ** module id = 891
 ** module chunks = 0
 **/